<template>
  <v-container grid-list-sm>
    <ProjectResponseHeader />
    <br />
    <ProjectResponseMenuTab :active="1" />
    <br />
    <v-card class="pa-4">
      <v-layout row wrap>
        <v-flex sm4 class="px-2"><GenderGraph /></v-flex>
        <v-flex sm4 class="px-2">
          <DivisionGraph />
        </v-flex>
        <v-flex sm4 class="px-2"><AgeGraph /></v-flex>
        <v-flex sm12 style="height: 15px" />
        <v-flex sm4 class="px-2"><EducationGraph /></v-flex>
        <v-flex sm4 class="px-2"><OccupationGraph /></v-flex>
        <v-flex sm4 class="px-2"><MonthlyIncomeGraph /></v-flex>
      </v-layout>
    </v-card>
  </v-container>
</template>
<script>
import GenderGraph from "../../components/project/graph/GenderGraph.vue";
import DivisionGraph from "../../components/project/graph/DivisionGraph.vue";
import AgeGraph from "../../components/project/graph/AgeGraph.vue";
import EducationGraph from "../../components/project/graph/EducationGraph.vue";
import OccupationGraph from "../../components/project/graph/OccupationGraph.vue";
import MonthlyIncomeGraph from "../../components/project/graph/MonthlyIncomeGraph.vue";
import ProjectResponseHeader from "../../components/project/ProjectResponseHeader";
import ProjectResponseMenuTab from "../../components/project/ProjectResponseMenuTab";
export default {
  components: {
    DivisionGraph,
    AgeGraph,
    GenderGraph,
    EducationGraph,
    OccupationGraph,
    MonthlyIncomeGraph,
    ProjectResponseHeader,
    ProjectResponseMenuTab,
  },
};
</script>
